import { useState } from "react"
import { getMarketPriceTrendsById } from "@/service/event/index";
import Image from "next/image";
import PercentageChart from './PercentageChart';

import btn_icon_diamond_png from "@/app/assets/common/btn_icon_diamond.png";
import btn_chart_png from "@/app/assets/event/btn_chart@2x.png"
import { Skeleton } from "antd";

export type MarketDataType = {
  aiPrediction: string,
  chanceDisplay: string,
  id: number,
  image: string,
  itemTitle: string,
  outcomeName1: string,
  outcomeName2: string,
  outcomePrice1: number,
  outcomePrice2: number,
  question: string
}

export type EventCardProps = {
  item: MarketDataType,
  onSellClick: () => void,
  onBuyClick: () => void
}

export type ChartDataType = {
  label: string,
  series: {
    data: number[],
    name: string
  }[],
  type: string,
  xAxis: string[]
  yAxisTicks: { name: string, value: number }[]
}

const MarketItem: React.FC<EventCardProps> = ({ item, onSellClick, onBuyClick }) => {

  const [showChart, setShowChart] = useState(false)
  const [chartData, setChartData] = useState<ChartDataType[]>()
  const getChartDataList = (id: number | string) => {
    getMarketPriceTrendsById<ChartDataType[]>(id).then(res => {
      if (res.code === 0) {
        setChartData([...res.data])
      }
    })
  }

  return <div className="m-10 rounded-20 py-17 px-20" style={{ backgroundColor: "rgba(72, 66, 101, 0.5)" }}>
    {/* <div className='flex items-center '>
            <Image
              src={item.image}
              alt={item.question} width="60" height="60"
              style={{ width: "6rem", height: "auto" }}
            />
            <div className='ml-10 text-bravve-200 font-bold text-15'>
              {item.question}
            </div>
          </div> */}
    <div className='flex items-center justify-between h-32'>
      <h5 className="font-bold text-15 leading-18 text-bravve-200 ">{item.itemTitle}</h5>
      <span className="font-semibold text-15 leading-20 text-bravve-100 flex items-center">
        {item.chanceDisplay}
        <div
          className='w-40 h-32 text-center leading-30 rounded-lg border ml-10'
          style={{ borderColor: 'rgba(255,255,255,0.2)' }}
          onClick={() => {
            setShowChart(pre => {
              if (!pre)
                getChartDataList(item.id)
              return !pre
            })
          }}
        >
          <Image src={btn_chart_png} alt='btn_chart' width={30} height={30} className='w-30 h-30 mx-auto' />
        </div>
      </span>
    </div>
    <div>
      {
        showChart ? chartData?.length ?
          <PercentageChart data={chartData} yesP={item.outcomePrice1} noP={item.outcomePrice2} />
          :
          <Skeleton active />
          :
          null
      }
    </div>
    <div className='mt-10 flex justify-between items-center'>
      <div className={'button_50p flex items-center justify-center font-semibold relative ' +
        (item.aiPrediction === item.outcomeName1 ? 'bg-bravve-100' : 'bg-bravve-200')}
        onClick={onBuyClick}
      >
        {item.aiPrediction === item.outcomeName1 &&
          <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
        <span className='text-xs text-bravve-sub-400' >{item.outcomeName1}</span>
        <span className='text-xl ml-5 text-bravve-300' >{item.outcomePrice1}</span>
        <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20}
          style={{ height: '2rem', width: '2rem' }} />
      </div>

      <div className={'button_50p flex items-center justify-center font-semibold relative ml-10 ' +
        (item.aiPrediction === item.outcomeName2 ? 'bg-bravve-100' : 'bg-bravve-200')}
        onClick={onSellClick}
      >
        {item.aiPrediction === item.outcomeName2 &&
          <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
        <span className='text-xs text-bravve-sub-400' >{item.outcomeName2}</span>
        <span className='text-xl ml-5 text-bravve-300' >{item.outcomePrice2}</span>
        <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20}
          style={{ height: '2rem', width: '2rem' }} />
      </div>
    </div>
  </div>
}

export default MarketItem;